module.exports = __webpack_public_path__ + "static/img/title-button-selected1.afc13368.png";